import React from "react";
import "./Loader.css";

const Loader = ({ pending = false }) => {
  return (
    <div
      className="loadin-main-box"
      style={pending ? { display: "flex" } : { display: "none" }}
    >
      {pending && (
        <>


          <div class="loader"></div>
        </>
      )}
    </div>
  );
};

export default Loader;